import React from 'react';
import { Link, } from 'react-router';
import $ from 'jquery';
import axios from 'axios';
import { Modal, } from 'react-bootstrap';
import '../../public/css/media/_checkout-success.scss';
import Footer from './Layout/Footer/Footer';
import { history, } from '../store';
import { maskLocationName } from '../utils/utils';
import CommonConstants from '../utils/CommonConstants';
import OutBoundBanner from './OutBoundBanner';
const apiUrl = CommonConstants.Actions.api;


/* eslint-disable */
var appConfig = require('webpack-config-loader!../app-config.js');
/* eslint-enable */
// const URL = appConfig.scUxUrl;

// const {
//   FacebookShareButton,
//   TwitterShareButton,
// } = ShareButtons;
// const FacebookIcon = generateShareIcon('facebook');
// const TwitterIcon = generateShareIcon('twitter');
const createReactClass = require('create-react-class');
const CheckOutSuccess = createReactClass({
  getInitialState() {
    return {
      viewImageAir: false,
      viewImageSea: false,
      imageAir: null,
      imageSea: null,
      isPageLoading: true
    }
  },
  componentWillMount() {
    let redirectResult = this.props.location.query.redirectResult;
    if (redirectResult) {
      axios.post(apiUrl+'adyen/payment/get-payment-details', {redirectResult: redirectResult}).then((res) => {
        this.setState({ isPageLoading: true })
        history.push(`/checkout-success?payment_type=adyen&authResult=${res.data.attributes.resultCode.toUpperCase()}&merchantReference=${res.data.attributes.merchantReference}&pspReference=${res.data.attributes.pspReference}&shopperLocale=en_GB`)
        window.location.reload()
      })
      return;
    }
    this.setState({ isPageLoading: false })
    if (Object.prototype.hasOwnProperty.call(this.props.location.query, 'authResult')) {
      let payment_provider = 'adyen';
      let payment_status = this.props.location.query.authResult;
      let reference_id = this.props.location.query.merchantReference;
      let psp_reference = this.props.location.query.pspReference;

      this.props.setPayment(payment_provider, payment_status, reference_id, null, psp_reference);

      if (payment_status === 'CANCELLED') {
        this.props.showCancelledPayment();
        history.push('cart');
      }

      if (payment_status === 'ERROR' || payment_status === 'REFUSED') {
        this.props.showErrorOnPayment();
        history.push('cart');
      }

    } else if(Object.prototype.hasOwnProperty.call(this.props.location.query, 'payment_type')){
      let payment_provider = this.props.location.query.payment_type;
      let reference_id = this.props.location.query.Ref;

      this.props.setPayment(payment_provider, "success", reference_id, null, null);

      if(this.props.customerCheckout.error && this.props.customerCheckout.error.response.data.errors.detail === "Transaction is not a valid for free shipping.") {
        this.props.showInvalidTransactionError();
        history.push('cart');
      }
    } else {
      let reference_id = Object.prototype.hasOwnProperty.call(this.props.location.query, 'Ref') ? this.props.location.query.Ref : this.props.location.query.token;
      var payment_provider = this.props.location.query.payment_provider;
      var payer_id = Object.prototype.hasOwnProperty.call(this.props.location.query, 'PayerID') ? this.props.location.query.PayerID : null;
      var payment_status = "success";

      this.props.setPayment(payment_provider, payment_status, reference_id, payer_id);
    }
    // if (localStorage.checkout_response) {
    //   var reference_id = localStorage.checkout_response;
    //   this.props.setPayment("asiapay", "success", reference_id);
    // }
    // else {
    //   reference_id = Object.prototype.hasOwnProperty.call(this.props.location.query, 'Ref') ? this.props.location.query.Ref : this.props.location.query.token;
    //   var payment_provider = this.props.location.query.payment_provider;
    //   var payer_id = Object.prototype.hasOwnProperty.call(this.props.location.query, 'PayerID') ? this.props.location.query.PayerID : null;
    //   var payment_status = "success";
    //   this.props.setPayment(payment_provider, payment_status, reference_id, payer_id);
    // }
    this.props.getCopyrightYear();
    $('#SCTitle').text("Payment Successful | ShippingCart");
  },
  componentWillReceiveProps(nextProps){
    if (nextProps.customerCheckout.error) {
     // if (nextProps.customerCheckout.error.response.status === 422){
     //   history.push('cart');
     // }
    }
    if (nextProps.customerCheckout.payment !== this.props.customerCheckout.payment){
      this.props.getGlobalSettings(nextProps.customerCheckout.payment.data.air ? nextProps.customerCheckout.payment.data.air.item[0].warehouse_id : nextProps.customerCheckout.payment.data.sea.item[0].warehouse_id);
    }
  },


  componentDidMount() {
    window.scrollTo(0, 0)
  },
  handleLogout() {
    localStorage.removeItem('jwtToken');
    this.props.logout();
  },
  viewImageAir(image) {
    this.setState({ viewImageAir: true, imageAir: image, });
  },
  viewImageSea(image) {
    this.setState({ viewImageSea: true, imageSea: image, });
  },
  close() {
    this.setState({ viewImageAir: false, viewImageSea: false, });
  },

  render() {
    const outboundBanner = this.props.settings && this.props.settings.globalSettings && this.props.settings.globalSettings.data.filter(data => data.name === 'outbound_banner');

    return (

      <div>
        
        <Modal show={this.state.viewImageAir} onHide={this.close} autoFocus={true}>
          <Modal.Header closeButton>
          </Modal.Header>
          <Modal.Body>
            <img src={this.state.imageAir} className="img-responsive adjust padding-bottom-25" alt="" />
          </Modal.Body>
        </Modal>
        <Modal show={this.state.viewImageSea} onHide={this.close} autoFocus={true}>
          <Modal.Header closeButton>
          </Modal.Header>
          <Modal.Body>
            <img src={this.state.imageSea} className="img-responsive adjust padding-bottom-25" alt="" />
          </Modal.Body>

        </Modal>

        <div className="home">
          <header className="site-header header-minimal">
            <div className="container">
              <div className="logo">
                <Link to="/home" className="clearfix">
                  <div className="main-img"></div>
                </Link>
              </div>
              <nav className="top-nav">
                <ul>
                  <li className="dropdown has-sub">
                    <Link className="dropdown-toggle" data-toggle="dropdown">Hello {this.props.login.fetched ? this.props.login.login.party.first_name : null}<i className="fa fa-angle-down"></i></Link>
                    <ul className="sub sub-account dropdown-menu ">
                      <li><Link to="/cart"> Cart </Link></li>
                      <li><Link to="/shipment"> Shipments</Link></li>
                      <li><Link to="/account"> Account </Link></li>
                      {this.props.parcelInfo.getParcel ? null : this.props.parcelInfo.getProhibited ? this.props.parcelInfo.prohibited.data.length > 0 ? <li>
                        <Link to="/prohibited">
                          Prohibited Items </Link>
                      </li> : null : null}
                      <li><Link to="/home" onClick={this.handleLogout}> Logout </Link></li>
                    </ul>
                  </li>

                </ul>
              </nav>
            </div>
          </header>
          <div className="body-wrapper">
            <div className="checkout container">
              <div className="checkout-top text-center">
                <div className="checkout-success">
                </div>
              </div>
              { this.state.isPageLoading ? <div className="loader checkout-wrapper clearfix" style={{ display: 'flex', justifyContent: 'center' }}>
              <i className="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
              <span className="sr-only">Loading...</span>
            </div> : <div className="checkout-wrapper clearfix">
                <div className="back-link">
                  <Link to="/shipment">&lt; Back to Shipments</Link>
                  <p>
                    Transaction #: {this.props.customerCheckout.fetched_payment ? this.props.customerCheckout.payment.transaction_id : null}
                  </p>
                </div>

                <h2>Thank you. Your payment is being processed.</h2>
                <h5>You will receive an email notification once your payment has been confirmed. Your package will then be queued for consolidation and shipping.</h5>
                {this.props.customerCheckout.fetched_payment && this.props.customerCheckout.payment.sc_protect && <h5>
                  <img src='https://cdn.shippingcart.com/assets/sc-protect-logo-final-20231123025932.svg' alt='badge' width={18} height={18} style={{ marginRight: '5px' }}/>
                  <span style={{fontSize: '10px', fontWeight: 600, color: '#636363'}}>SC Protect, powered by Stere & underwritten by PLGIC, is a partnership between SC and SPI.</span>
                </h5>}

                <br /> <br />
                <div style={{margin: '10px 0px', display: 'flex', justifyContent: 'center'}}>
                  {/* dynamic Banner */}
                  {this.props.settings && this.props.settings.globalSettings && 
                    <div style={{maxWidth: '50%'}}>
                      <OutBoundBanner outBoundBannerData={outboundBanner}/>
                    </div>
                  }
                </div>
                <br />
                <div className="shipment-list">
                  {this.props.customerCheckout.fetched_payment && this.props.customerCheckout.payment.data.hasOwnProperty('air') ?

                    <div className="shipment-head clearfix">
                      <div className="shipment-type checkout" style={{display: 'inline-flex', padding: '20px', justifyContent: 'left'}}>
                        <img src='https://cdn.shippingcart.com/assets/001-plane-20230321064808.svg' alt='air' width={24} style={{marginRight: '10px'}}/>
                        <div style={{fontSize: '16px', fontWeight: 600}}>Air Cargo</div>
                      </div>

                    </div> : null}


                  {this.props.customerCheckout.fetched_payment && this.props.customerCheckout.payment.data.hasOwnProperty('air') ?

                    <div className="shipment-box clearfix">
                      <div className="shipment-box-wrapper">
                        <div data-do="image-modal" className="shipment-image">
                          <h5>{}</h5>
                          {this.props.customerCheckout.payment.data.air.item.map((item) =>
                            item.images.map((image, i) =>
                              <div key={i}>
                                <a onClick={this.viewImageAir.bind(this, image)} data-toggle="lightbox" data-gallery="hiddenimages">
                                  <img src={image} className="img-responsive" alt="" />
                                </a>
                              </div>
                            )
                          )}

                        </div>
                        <div className="shipment-item">
                          <h6>Item/s</h6>
                          <ul>
                            {this.props.customerCheckout.payment.data.air.item.map((item, i) =>
                              <li key={i}>
                                {item.description}
                                {item.flags.is_abandoned ? <span className="icon-hope"/> : null}
                              </li>
                            )}
                          </ul>
                        </div>
                        <div className="shipment-status">
                          <h6>Ship to:</h6>
                          <p>

                            {this.props.customerCheckout.payment.data.air.address.name}<br />
                            {this.props.customerCheckout.payment.data.air.address.line_1},&nbsp;{this.props.customerCheckout.payment.data.air.address.line_2},<br />
                            {this.props.customerCheckout.payment.data.air.address.city},&nbsp;{this.props.customerCheckout.payment.data.air.address.state},<br />
                            {maskLocationName(this.props.customerCheckout.payment.data.air.address.country_code)},&nbsp;{this.props.customerCheckout.payment.data.air.address.postal_code}<br />
                            {this.props.customerCheckout.payment.data.air.address.phone_number || this.props.login.login.party.phone_number}
                          </p>
                        </div>
                        <div className="shipment-update" data-lazy="true" data-lazy-id="68577" data-lazy-tracking="1095781790" data-lazy-status="PAID" data-lazy-delivered-date="">
                          <div className="tracking-update">
                            <div className="track-and-trace">
                              <div className="top-label"><strong>Delivery Date:</strong></div>
                              <div className="update-date">{this.props.customerCheckout.payment.data.delivery.air}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    : null}
                  {this.props.customerCheckout.fetched_payment && this.props.customerCheckout.payment.data.hasOwnProperty('sea') ?
                    <div className="shipment-head clearfix">
                      <div className="shipment-type checkout" style={{display: 'inline-flex', padding: '20px', justifyContent: 'left'}}>
                        <img src='https://cdn.shippingcart.com/assets/037-cargo-ship-20230321064815.svg' alt='sea' width={24} style={{marginRight: '10px'}}/>
                        <div style={{fontSize: '16px', fontWeight: 600}}>Sea Cargo</div>
                      </div>
                    </div> : null}
                  {this.props.customerCheckout.fetched_payment && this.props.customerCheckout.payment.data.hasOwnProperty('sea') ?

                    <div className="shipment-box clearfix">
                      <div className="shipment-box-wrapper">
                        <div data-do="image-modal" className="shipment-image">
                          <h5>{}</h5>
                          {this.props.customerCheckout.payment.data.sea.item.map((item) =>
                            item.images.map((image, i) =>
                              <div key={i}>
                                <a key={i} onClick={this.viewImageSea.bind(this, image)} data-toggle="lightbox" data-gallery="hiddenimages">
                                  <img src={image} className="img-responsive" alt="" />
                                </a>
                              </div>
                            )

                          )}

                        </div>
                        <div className="shipment-item">
                          <h6>Item/s</h6>
                          <ul>
                            {this.props.customerCheckout.payment.data.sea.item.map((item, i) =>
                              <li key={i}>
                                {item.description}
                                {item.flags.is_abandoned ? <span className="icon-hope"/> : null}
                              </li>
                            )}
                          </ul>
                        </div>
                        <div className="shipment-status">
                          <h6>Ship to:</h6>
                          <p>

                            {this.props.customerCheckout.payment.data.sea.address.name} <br />
                            {this.props.customerCheckout.payment.data.sea.address.line_1},&nbsp;{this.props.customerCheckout.payment.data.sea.address.line_2},<br />
                            {this.props.customerCheckout.payment.data.sea.address.city},&nbsp;{this.props.customerCheckout.payment.data.sea.address.state},<br />
                            {maskLocationName(this.props.customerCheckout.payment.data.sea.address.country_code)},&nbsp;{this.props.customerCheckout.payment.data.sea.address.postal_code}<br />
                            {this.props.customerCheckout.payment.data.sea.address.phone_number || this.props.login.login.party.phone_number}
                          </p>
                        </div>
                        <div className="shipment-update" data-lazy="true" data-lazy-id="68577" data-lazy-tracking="1095781790" data-lazy-status="PAID" data-lazy-delivered-date="">
                          <div className="tracking-update">
                            <div className="track-and-trace">
                              <div className="top-label"><strong>Delivery Date:</strong></div>
                              <div className="update-date">{this.props.customerCheckout.payment.data.delivery.sea}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : null}

                </div>
                <div style={{display: 'inline-flex', width: '100%', justifyContent: 'space-between'}}>
                  <div className="back-link" style={{placeSelf: 'center', margin: '0px'}}>
                    <Link to="/shipment">&lt; Back to Shipments</Link>
                  </div>
                  <a href="/referral?utm_source=web&utm_medium=checkout&utm_campaign=ph-web-checkout-referral-20220727" style={{marginRight: '28px'}}>
                    <button className="btn btn-orange referral-button">REFERRAL PROMO | LEARN MORE</button>
                  </a>
                </div>
              </div>}

              <div className="bottom-shadow"></div>
            </div>
          </div>
        </div>
        <Footer
          currentPath={this.props.location.pathname}
          currentYear={this.props.login.year}
        />

      </div>
    )

  },

});

export default CheckOutSuccess;



/** WEBPACK FOOTER **
 ** ./src/components/CheckOutSuccess.js
 **/